import { datadogRum } from '@datadog/browser-rum';
import * as Sentry from '@sentry/node';
import axios from 'axios';
import firebase from 'firebase';
import moment from 'moment';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, ListGroup, Row, Toast } from 'react-bootstrap';
import SVG from 'react-inlinesvg';
import database from '../../SDKs/firebase/firebase';
import BookingPaymentGratuity from '../../components/BookingPaymentGratuity';
import ContextComponent from '../../components/ContextComponent';
import GratuitySelection from '../../components/GratuitySelection';
import Layout from '../../components/Layout';
import OpenGraphDescription from '../../components/OpenGraphDescription';
import OpenGraphTitle from '../../components/OpenGraphTitle';
import Section from '../../components/Section';
import SwooptyBg from '../../components/SwooptyBg';
import ToastWrapper from '../../components/ToastWrapper';
import Head from '../../components/head';
import { FranchiseeProvider } from '../../context/Franchisee';
import { PaymentProvider } from '../../context/Payment';
export type AppointmentData = {
  appointmentId: number;
};

interface CustomerData {
  customerAddressLineOne: string;
  franchiseeName: string;
  customerFirstName: string;
  customerAddressLineTwo: string;
  franchiseeState: string;
  appointmentPrice: string;
  customerId: number;
  appointmentDate: string;
  customerLastName: string;
}
const Gratuity: React.FC<CustomerData> = () => {
  const iconKitchen = '/images/icon-kitchen.svg';
  const iconSparkles = '/images/sparkles-two.svg';

  const [appointmentDate, setAppointmentDate] = useState<string>('');
  const [appointmentPrice, setAppointmentPrice] = useState<string>('');
  const [appointmentTip, setAppointmentTip] = useState<number>(0);

  const [customerAddressLineOne, setCustomerAddressLineOne] =
    useState<string>('');
  const [customerAddressLineTwo, setCustomerAddressLineTwo] =
    useState<string>('');
  const [customerFirstName, setCustomerFirstName] = useState<string>('');
  const [customerLastName, setCustomerLastName] = useState<string>('');
  const [customerId, setCustomerId] = useState<number>(null);
  const [appointmentId, setAppointmentId] = useState<number>(null);
  const [teamMemberIds, setTeamMemberIds] = useState<any>([]);
  const [teamID, setTeamId] = useState<number>();

  const [franchiseeName, setFranchiseeName] = useState<string>('');
  const [franchiseeState, setFranchiseeState] = useState<string>('');
  const [franchisee, setFranchisee] = useState<any>(null);
  const [appointmentExpired, setAppointmentExpired] = useState<boolean>(false);
  const [appointmentMoreThanSevenDays, setAppointmentMoreThanSevenDays] =
    useState<boolean>(false);
  const [submittedTipAmount, setSubmittedTipAmount] = useState<number>(0);
  const [customerData, setCustomerData] = useState<any>({});
  const [creditCardSubmitted, setCreditCardSubmitted] =
    useState<boolean>(false);
  const [appointmentCharged, setAppointmentCharged] = useState<boolean>(false);
  const [appointmentPaid, setAppointmentPaid] = useState<boolean>(false);
  const [showCreditCardField, setShowCreditCardField] = useState<boolean>(true);

  const [vaultID, setVaultID] = useState<string>('');
  const [collectJsToken, setCollectJsToken] = useState<string>('');

  const [creditCardAction, setCreditCardAction] = useState<string>('');

  const [appointmentPackageId, setAppointmentPackageId] =
    useState<number>(null);

  const [isChecked, setIsChecked] = useState<boolean>(true);

  const [showErrorToast, setShowErrorToast] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');

  // const [customerZipCode, setCustomerZipCode] = useState<string>('');

  const router = useRouter();
  let db = database.app.database('https://maid-dashboard.firebaseio.com/');

  const getDaysInBetween = (cleaningDate) => {
    const currentTime = new Date();
    var start = moment(currentTime, 'YYYY-MM-DD');
    var end = moment(cleaningDate, 'YYYY-MM-DD');
    console.log(start);
    console.log(end);
    let diff = moment.duration(end.diff(start)).asDays();
    console.log(diff);
    return diff;
  };

  useEffect(() => {
    const url = window.location.href;
    const splitUrl = url.split('payment-method/')[1];
    const encryptedMessage = splitUrl.split('==')[0] + '==';
    const secretKey = splitUrl.split('==')[1];
    // const slug = router.query.slug;
    console.log('url', url);
    // set franchisee name to slug but with capital first letter
    const slug = url.split('?')[1].split('=')[1].split('&')[0];
    console.log('slug', slug);

    const franchiseeName = slug[0].toUpperCase() + slug.slice(1);
    setFranchiseeName(franchiseeName);
    console.log(slug);
    axios
      .post('/api/get-customer-from-id/', {
        baseMessage: encryptedMessage,
        key: secretKey,
      })
      .then((data: any) => {
        console.log('data', data);
        const customer_info = data.data;

        setCustomerData({
          firstName: customer_info.customerFirstName,
          lastName: customer_info.customerLastName,
          addressLineOne: customer_info.customerAddressLineOne,
          addressLineTwo: customer_info.customerAddressLineTwo,
          city: customer_info.customerCity,
          state: customer_info.customerState,
          zipCode: customer_info.customerZipCode,
          phonePrimary: customer_info.customerPhonePrimary,
          email: customer_info.customerEmail,
          franchiseeSlug: slug,
          vaultId: customer_info.customerVault_id || null,
          shippingAddressOne: customer_info.customerAddressLineOne,
          shippingAddressTwo: customer_info.customerAddressLineTwo,
          shippingCity: customer_info.customerAddressLineTwo,
          shippingZipCode: customer_info.customerZipCode,
          shippingState: customer_info.customerState,
          id: customer_info.customerId,
        });
        // try {
        //   datadogRum.setUser({
        //     name: `${customer_info.customerFirstName} ${customer_info.customerLastName}`,
        //     email: customer_info.customerEmail,
        //   });
        // } catch (error) {
        //   console.log(error);
        // }

        console.log('slug', slug);
        axios
          .post('/api/get-locations/')
          .then(async (res) => {
            let result = res.data.data.find(
              (franchise) => franchise.slug === slug
            );
            if (result === undefined) return;
            console.log({ result });
            setFranchisee(result);
            setCollectJsToken(result.franchisee_preferences.collectJsToken);
          })
          .catch((e) => {
            console.log(e);
          });
      })
      .catch((e) => {
        console.log(e);
        // router.push('/404/');
        Sentry.captureException(e);
      });
  }, []);

  const submitCreditCard = (collectJsVaultId) => {
    console.log('submitting credit card');
    axios
      .post('/api/capture-credit-card/', {
        customer: customerData.id,
        vaultId: Number(collectJsVaultId),
        franchiseeId: franchisee.id,
      })
      .then((res) => {
        if (res.data.message.includes('Failed')) {
          setShowErrorToast(true);
          Sentry.captureException(res.data.message);
          setErrorMessage(res.data.message);
        } else {
          setCreditCardSubmitted(true);
        }
      })
      .catch((err) => {
        Sentry.captureException(err);

        console.log(err);
      });
    // setCreditCardSubmitted(true);
  };
  const handleShowCreditCard = (action) => {
    setCreditCardAction(action);
    setShowCreditCardField(true);
  };

  const handleErrorToast = () => {
    setShowErrorToast(true);
  };

  return (
    <>
      {customerData?.firstName && (
        <FranchiseeProvider franchiseeValue={franchisee}>
          <Layout alternateFooter>
            <Head
              slug='payment-method'
              title='Payment Method | Two Maids '
              description='See why Two Maids  is a Maid Service worth talking about!'
            />
            <OpenGraphTitle
              title={`Payment Method  | Two Maids ${franchiseeName}`}
            />
            <OpenGraphDescription>
              {/* Add About description here */}
              {`Payment Method  | Two Maids  ${franchiseeName}`}
            </OpenGraphDescription>
            <div
              className='test'
              style={{ minHeight: '100vh', overflow: 'scroll' }}
            >
              <Section>
                <ToastWrapper>
                  <Toast
                    show={showErrorToast}
                    onClose={() => setShowErrorToast(false)}
                    autohide
                    delay={5000}
                  >
                    <Toast.Body
                      className='toast-error'
                      style={{ background: '#dc3545' }}
                    >
                      {errorMessage}
                    </Toast.Body>
                  </Toast>
                </ToastWrapper>
                <Row className='justify-content-center mt-2'>
                  <Col xs={12} md={10} lg={8} className='mt-2'>
                    <h1
                      className='h1 text-center text-capitalize mb-4'
                      style={{ color: '#d4367f', fontSize: '3rem' }}
                    >
                      Hello, {customerData.firstName} {customerData.lastName}!
                    </h1>

                    <div>
                      <h1
                        className='h2 text-center mb-5'
                        style={{ fontSize: '2rem' }}
                      >
                        Please enter your credit card details below. Your card will only be charged on the day of your cleaning. We look forward to serving you soon.
                      </h1>

                      <div
                        id='booking-form-confirmation'
                        className='mt-0 mb-10 px-2'
                      >
                        <div>
                          {vaultID && !showCreditCardField && (
                            <h4 style={{ textAlign: 'center' }}>
                              Thank you for your submission!
                            </h4>
                          )}
                          {!vaultID &&
                            !creditCardSubmitted &&
                            appointmentCharged === false &&
                            appointmentPaid === true && (
                              <h4 style={{ textAlign: 'center' }}>
                                Please enter credit card information.
                              </h4>
                            )}
                          {creditCardSubmitted && (
                            <h4 style={{ textAlign: 'center' }}>
                              Thank you for your submission!
                            </h4>
                          )}
                        </div>
                        {showCreditCardField &&
                          !creditCardSubmitted &&
                          collectJsToken && (
                            <PaymentProvider>
                              <BookingPaymentGratuity
                                franchisee={franchisee}
                                customerData={customerData}
                                submittedTipAmount={submittedTipAmount}
                                submitCreditCard={submitCreditCard}
                                collectJsToken={collectJsToken}
                              />
                            </PaymentProvider>
                          )}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Section>
            </div>

            <div className='icon__kitchen'>
              <Container className='position-relative'>
                {/* <SVG src={iconSparkles} title='Sparkle' />
                <SVG src={iconSparkles} title='Sparkle' />
                <SVG src={iconSparkles} title='Sparkle' />
                <SVG src={iconKitchen} title='A clean kitchen' /> */}
              </Container>
            </div>
            <ContextComponent franchisee={franchisee} />
          </Layout>
        </FranchiseeProvider>
      )}
    </>
  );
};

export default Gratuity;
